import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'infoUpdate');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/communityInfoUpdate.js